import { SearchType } from "components/search/search/types";

const env = import.meta.env.VITE_ENV;
export const indexName = {
  Authors: `Author_${env}`,
  Books: `Book_${env}`,
  Characters: `Character_${env}`,
  Series: `Series_${env}`,
  Lists: `List_${env}`,
  Prompts: `Prompt_${env}`,
  Publishers: `Publisher_${env}`,
  Users: `User_${env}`,
};

export function indexLookup(type: SearchType) {
  return indexName[type];
}
